import { createFileRoute, notFound } from '@tanstack/react-router'
import { allPages } from 'content-collections'
import { Markdown } from '@/components/ui/markdown'

export const Route = createFileRoute('/_public/privacy')({
  staticData: {
    title: 'Privacy Policy — PhoneSalad',
    description: 'Learn how PhoneSalad collects, uses, and protects your personal data. We are committed to keeping your information safe and secure.',
    sitemap: { priority: '0.3', changefreq: 'yearly' },
  },
  loader: () => {
    const page = allPages.find((p) => p.slug === 'privacy-policy')
    if (!page) throw notFound()
    return page
  },
  component: PrivacyPage,
})

function PrivacyPage() {
  const page = Route.useLoaderData()

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-8 pt-20">
        <div className="max-w-4xl mx-auto">
          <div className="prose prose-lg dark:prose-invert max-w-none">
            <Markdown content={page.content} />
          </div>
        </div>
      </div>
    </div>
  )
}
